import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';
import { MeasureUnitsSettings } from './settings-measure-units.component';

export function provideSettingsElementMeasureUnits(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'measure-units',
        name: 'Measure units',
        icon: 'pi pi-gauge',
        component: MeasureUnitsSettings,
        order: 6,
        translateName: 'SETTINGS_MEASURE_UNITS.TITLE',
        // Capacity is no longer a plan feature — it follows custom-object definition permissions.
        // The `capacity` resource key is still computed on the backend (now derived from the
        // custom-objects:definitions grants), so it stays purely RBAC-gated with no plan upsell.
        resource_key: 'capacity',
        required_action: 'read',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'workspace',
          name: 'Workspace',
          order: 1,
          translateName: 'SETTINGS.CATEGORIES.WORKSPACE',
        },
      },
      multi: true,
    },
  ]);
}
